export const DEFAULT_DISPLAY_TEXT_FOR_CONTENT_ITEMS = {
  itemTypeName: {
    singular: 'item',
    plural: 'items',
  },
};
